package pl.mothdigital.neuronowi.components.sections.contactmap

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.*
import org.jetbrains.compose.web.dom.*

@Composable
fun MapSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        Div(
            attrs = Modifier
                .margin { auto }
                .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
                .toAttrs(),
        ) {
            Iframe(
                attrs = {
                    attr(
                        "src",
                        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2433.504373768818!2d15.5062108!3d51.9394364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4705ac126c9e9d2b%3A0xf1e6474cd179b993!2sFabryczna%2017A%2C%2065-410%20Zielona%20G%C3%B3ra!5e0!3m2!1spl!2spl!4v1715361000000"
                    )
                    attr("width", "100%")
                    attr("height", "400")
                    attr("style", "border:0; border-radius: 12px;")
                    attr("allowfullscreen", "")
                    attr("loading", "lazy")
                    attr("referrerpolicy", "no-referrer-when-downgrade")
                }
            )
        }
    }
}
